"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderCard = void 0;
const snap_ui_1 = require("@teamsnap/snap-ui");
const teamsnap_ui_1 = require("@teamsnap/teamsnap-ui");
const api_1 = require("core/api");
const React = __importStar(require("react"));
// Local Imports
const constants_1 = require("core/constants");
const app_1 = require("ducks/app");
const installment_preview_1 = require("./installment-preview");
require("./order-card.scss");
const PaymentsIcon = () => (React.createElement("svg", { width: "22", height: "16", viewBox: "0 0 22 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M13 9C12.1667 9 11.4583 8.70833 10.875 8.125C10.2917 7.54167 10 6.83333 10 6C10 5.16667 10.2917 4.45833 10.875 3.875C11.4583 3.29167 12.1667 3 13 3C13.8333 3 14.5417 3.29167 15.125 3.875C15.7083 4.45833 16 5.16667 16 6C16 6.83333 15.7083 7.54167 15.125 8.125C14.5417 8.70833 13.8333 9 13 9ZM6 12C5.45 12 4.97917 11.8042 4.5875 11.4125C4.19583 11.0208 4 10.55 4 10V2C4 1.45 4.19583 0.979167 4.5875 0.5875C4.97917 0.195833 5.45 0 6 0H20C20.55 0 21.0208 0.195833 21.4125 0.5875C21.8042 0.979167 22 1.45 22 2V10C22 10.55 21.8042 11.0208 21.4125 11.4125C21.0208 11.8042 20.55 12 20 12H6ZM8 10H18C18 9.45 18.1958 8.97917 18.5875 8.5875C18.9792 8.19583 19.45 8 20 8V4C19.45 4 18.9792 3.80417 18.5875 3.4125C18.1958 3.02083 18 2.55 18 2H8C8 2.55 7.80417 3.02083 7.4125 3.4125C7.02083 3.80417 6.55 4 6 4V8C6.55 8 7.02083 8.19583 7.4125 8.5875C7.80417 8.97917 8 9.45 8 10ZM2 16C1.45 16 0.979167 15.8042 0.5875 15.4125C0.195833 15.0208 0 14.55 0 14V4C0 3.71667 0.0958333 3.47917 0.2875 3.2875C0.479167 3.09583 0.716667 3 1 3C1.28333 3 1.52083 3.09583 1.7125 3.2875C1.90417 3.47917 2 3.71667 2 4V14H18C18.2833 14 18.5208 14.0958 18.7125 14.2875C18.9042 14.4792 19 14.7167 19 15C19 15.2833 18.9042 15.5208 18.7125 15.7125C18.5208 15.9042 18.2833 16 18 16H2Z", fill: "#536878" })));
const CardIcon = () => (React.createElement("svg", { width: "20", height: "16", viewBox: "0 0 20 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M20 2V14C20 14.55 19.8043 15.021 19.413 15.413C19.021 15.8043 18.55 16 18 16H2C1.45 16 0.979333 15.8043 0.588 15.413C0.196 15.021 0 14.55 0 14V2C0 1.45 0.196 0.979333 0.588 0.588C0.979333 0.196 1.45 0 2 0H18C18.55 0 19.021 0.196 19.413 0.588C19.8043 0.979333 20 1.45 20 2ZM2 4H18V2H2V4ZM2 8V14H18V8H2Z", fill: "#536878" })));
const formatMethod = (paymentMethod) => {
    if (typeof paymentMethod.accountName === 'string') {
        if (paymentMethod.accountName === 'offline') {
            if (typeof paymentMethod.accountType === 'string') {
                return `OFFLINE (${paymentMethod.accountType.slice(0, 1).toUpperCase() + paymentMethod.accountType.slice(1).toLowerCase()})`;
            }
            return;
        }
        return `${paymentMethod.accountName.toUpperCase()} (**** ${paymentMethod.last4})`;
    }
    else {
        return `${paymentMethod.accountName} (**** ${paymentMethod.last4})`;
    }
};
const getLatestPaymentMethod = (installments) => installments?.slice(-1)[0]?.paymentMethod;
var StatusClasses;
(function (StatusClasses) {
    StatusClasses["PAID"] = "orders-card--paid";
    StatusClasses["CANCELED"] = "orders-card--canceled";
    StatusClasses["BALANCE_EXISTS"] = "orders-card--balance";
    StatusClasses["BALANCE_OUTSTANDING"] = "orders-card--outstanding";
})(StatusClasses || (StatusClasses = {}));
const OrderCard = ({ order, profile }) => {
    const [showInsuranceTooltip, setShowInsuranceTooltip] = React.useState(false);
    const [expanded, setExpanded] = React.useState(false);
    const [installments, setInstallments] = React.useState([]);
    const [paymentMethod, setPaymentMethod] = React.useState();
    const handleSelected = async () => {
        if (expanded === true) {
            setExpanded(!expanded);
        }
        else {
            try {
                const data = await api_1.OrdersService.getInstallments(order.id, order.amount > 0);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                setInstallments(data);
                data && setPaymentMethod(getLatestPaymentMethod(data));
                setExpanded(!expanded);
            }
            catch (error) {
                setInstallments([]);
                return (0, app_1.appFeedbackMessageError)('Oops! Something went wrong. Unable to load installments.');
            }
        }
    };
    const onDigitalAgreementsClick = () => {
        window.location.href = `${constants_1.ORDERS_URL}/order/${order.id}/agreements`;
    };
    const handleOrderConfirmationRedirect = () => {
        window.location.href = `${constants_1.ORDERS_URL}/order/${order.id}/confirmation`;
    };
    const handlePayBalanceRedirect = () => {
        window.location.href = `${constants_1.ORDERS_URL}/order/${order.id}/payment?option=pay_balance`;
    };
    const handleUpdateMethodRedirect = () => {
        window.location.href = `${constants_1.ORDERS_URL}/order/${order.id}/update-payment-method`;
    };
    const displayBalance = () => {
        if (order.status === 'canceled') {
            return 'Canceled';
        }
        if (order.status === 'fully_paid' || order.status === 'overpaid') {
            return 'Paid';
        }
        if (order.amountRemaining > 0) {
            return `Balance ${(0, installment_preview_1.getFormattedAmount)(order.amountRemaining / 100)}`;
        }
    };
    const calculateStatusClasses = () => {
        switch (displayBalance()) {
            case 'Paid':
                return StatusClasses.PAID;
            case 'Canceled':
                return StatusClasses.CANCELED;
            case `Balance ${(0, installment_preview_1.getFormattedAmount)(order.amountRemaining / 100)}`:
                if (order.status === 'scheduled') {
                    return StatusClasses.BALANCE_EXISTS;
                }
                else {
                    return StatusClasses.BALANCE_OUTSTANDING;
                }
            default:
                return '';
        }
    };
    const orderInsuranceItems = React.useMemo(() => {
        return [
            ...new Set(order.orderLineItems
                .filter((lineItem) => lineItem.scopeType === 'partner_offering')
                .map((lineItem) => lineItem.name)),
        ];
    }, [order]);
    return (React.createElement("div", { className: "u-sizeFull u-padMd u-spaceBottomSm OrderCard", role: "checkbox", "aria-checked": expanded, tabIndex: 0, "data-testid": "orderTile" },
        React.createElement(teamsnap_ui_1.Cell, { mods: "u-flex" },
            React.createElement("div", { className: "order-card--carat u-flex u-flexAlignItemsBaseline u-flexExpandRight" },
                React.createElement("button", { type: "button", className: "u-borderNone u-padNone u-colorInfo u-spaceRightSm", style: { backgroundColor: 'transparent' }, onClick: handleSelected, "data-testid": "orderExpandButton" }, expanded ? React.createElement(teamsnap_ui_1.Icon, { name: "down" }) : React.createElement(teamsnap_ui_1.Icon, { name: "right" })),
                React.createElement("h3", null,
                    React.createElement("span", { "data-testid": "orderNumber" },
                        "Order #",
                        order.orderNumber),
                    orderInsuranceItems.length > 0 && (React.createElement(snap_ui_1.Tooltip, { open: showInsuranceTooltip },
                        React.createElement(snap_ui_1.TooltipTrigger, { asChild: true },
                            React.createElement("button", { type: "button", className: "u-borderNone u-padNone u-colorInfo u-spaceRightSm", style: { backgroundColor: 'transparent' }, onClick: () => setShowInsuranceTooltip(!showInsuranceTooltip), "data-testid": "showInsuranceTooltipButton" },
                                React.createElement(snap_ui_1.Icon, { name: "verified_user", className: "sui-text-green-40 sui-ml-1 order-card--insurance" }))),
                        React.createElement(snap_ui_1.TooltipContent, null,
                            React.createElement("div", { className: "order-card--tooltip" },
                                React.createElement("div", { className: "sui-body" },
                                    orderInsuranceItems.join(' and '),
                                    " provided by",
                                    ' ',
                                    React.createElement("a", { href: "https://vi-coverage.com", target: "_blank", className: "sui-underline" }, "Vertical Insure")),
                                React.createElement(snap_ui_1.TooltipAction, { asChild: true, variant: "tertiary", size: "small", onClick: () => setShowInsuranceTooltip(false) }, "Close"))))))),
            React.createElement("div", { className: 'u-textCenter u-padSidesLg u-flexAlignSelfBaseline orders-card--balance-pill ' + calculateStatusClasses(), "data-testid": "displayBalance" }, displayBalance())),
        React.createElement(teamsnap_ui_1.Cell, null,
            React.createElement("p", { className: "u-flex u-spaceBottomNone u-padSidesSm", "data-testid": "householdPerson" }, `${profile.firstName} ${profile.lastName}`),
            React.createElement("p", { className: "u-flex u-spaceBottomNone u-padSidesSm", "data-testid": "orderPlacedOn" }, (0, installment_preview_1.getDateString)(order.insertedAt)),
            React.createElement(snap_ui_1.LabelButton, { className: "sui-p-1", labelText: "Order Confirmation", variantType: "tertiary", onClick: handleOrderConfirmationRedirect, "data-testid": "orderConfirmationButton" }),
            order.hasFormResultWithWaiver && (React.createElement(snap_ui_1.LabelButton, { className: "sui-p-1", labelText: "Digital Agreements", variantType: "tertiary", onClick: onDigitalAgreementsClick, "data-testid": "digitalAgreementsButton" })),
            expanded && paymentMethod && order.status !== 'fully_paid' && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-padEndsSm u-flex u-spaceBottomXs" },
                React.createElement("span", { className: "u-size1of12" },
                    React.createElement(CardIcon, null)),
                React.createElement("small", { className: "u-flexGrow1", "data-testid": "currentPaymentMethod" },
                    "Saved payment method: ",
                    formatMethod(paymentMethod)))),
            expanded && !paymentMethod && order.status !== 'fully_paid' && order.status !== 'waiting_for_payment' && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-padEndsSm u-flex u-spaceBottomXs" },
                React.createElement("span", { className: "u-size1of12" },
                    React.createElement(CardIcon, null)),
                React.createElement("small", { className: "u-flexGrow1", "data-testid": "currentPaymentMethod" }, "No saved payment method")))),
        expanded && order.status === 'waiting_for_payment' && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-spaceTopMd u-padSidesSm" },
            React.createElement("div", { className: "u-flex u-flexAlignItemsCenter" },
                React.createElement(PaymentsIcon, null),
                React.createElement("p", { className: "u-colorNeutral6 sui-ml-2 sui-mb-0" },
                    "Saved payment method: CASH ",
                    React.createElement("br", null),
                    "Payment status updates when organization admin records the payment.")))),
        expanded && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-spaceTopMd u-padSidesSm" },
            React.createElement(installment_preview_1.InstallmentPreview, { installments: installments, isPayable: order.amountRemaining > 0, order: order }))),
        expanded && order.amountRemaining > 0 && paymentMethod && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-padSidesMd u-padEndsMd u-flex u-flexJustifyBetween u-flexAlignItemsCenter u-borderTop u-spaceBottomXs", style: { margin: '0 -16px -16px' } },
            React.createElement("span", { className: "u-size1of12" },
                React.createElement(CardIcon, null)),
            React.createElement("small", { className: "u-flexGrow1" },
                "Saved payment method: ",
                React.createElement("br", null),
                formatMethod(paymentMethod)),
            React.createElement(teamsnap_ui_1.Button, { onClick: handleUpdateMethodRedirect, icon: "edit", mods: "u-padSidesSm" }))),
        expanded && order.amountRemaining > 0 && !paymentMethod && order.status !== 'waiting_for_payment' && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-padSidesMd u-padEndsMd u-flex u-flexJustifyBetween u-flexAlignItemsCenter u-borderTop u-spaceBottomXs", style: { margin: '0 -16px -16px' } },
            React.createElement("span", { className: "u-size1of12" },
                React.createElement(CardIcon, null)),
            React.createElement("small", { className: "u-flexGrow1" }, "No saved payment method"),
            React.createElement(teamsnap_ui_1.Button, { onClick: handleUpdateMethodRedirect, icon: "edit", mods: "u-padSidesSm" }))),
        expanded && order.amountRemaining > 0 && (React.createElement(teamsnap_ui_1.Cell, { mods: "u-padSidesMd u-padEndsMd u-flex u-flexJustifyBetween u-flexAlignItemsCenter u-borderTop", style: { margin: '0 -16px -16px' } },
            React.createElement("span", { className: "u-size1of12" },
                React.createElement(PaymentsIcon, null)),
            React.createElement("small", { className: "u-flexGrow1" },
                "Pay off balance ",
                React.createElement("br", null),
                (0, installment_preview_1.getFormattedAmount)(order.amountRemaining / 100)),
            React.createElement(teamsnap_ui_1.Button, { onClick: handlePayBalanceRedirect, icon: "arrow-right", mods: "u-padSidesSm" })))));
};
exports.OrderCard = OrderCard;
exports.default = exports.OrderCard;
